import { Icon, styled, theme } from '@yuno/design-system-web'

const CaretIcon = styled(Icon)`
  margin: 0 14px;
`

export const CaretIconStyled = () => (
  <CaretIcon
    name={'CaretRight'}
    size="12px"
    weight={'bold'}
    color={theme.palette.grey[5]}
  />
)
